import React, {useEffect, useState} from 'react';
import {Button, Col, Container, NavbarBrand, NavDropdown, NavItem, Row} from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav'
import {getUserInfo} from '../services/UserService';
import Navbar from 'react-bootstrap/Navbar'
import {useAuth} from '../contexts/AuthContext';
import {Link, useHistory} from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown'
import leadtubLogoWhite from '../assets/logo/leadtubLogoWhite.png'
import '../style/LeftsideNavbar.css'
import {svgs} from "./CONSTANTS";

const MobileNavBar = () => {

    const {currentUser, logout, handleEmailVerification, trulyAuthenticated} = useAuth();
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState({});


    useEffect(() => {

        const getUser = async () => {
            if (currentUser) {
                setUser(await getUserInfo(currentUser.uid))

            }
        }
        getUser()

        return (() => {
            getUser()
        })
    }, [currentUser])


    const handleClick = async () => {
        logout()
    }

    const handleVerify = async () => {
        setLoading(true)
        const res = await handleEmailVerification()
        if (res)
            setLoading(false)
    }


    return (
        <React.Fragment>

            {!loading && currentUser && trulyAuthenticated ? (
                <Navbar bg="dark" sticky={"top"}>
                    <Container fluid>


                        <Nav className="me-auto my-2 my-lg-0"
                             variant="pills"
                             bg="dark">
                            <NavDropdown title={
                                <span style={{color: "#fff"}}>Meny</span>
                            }
                                         id="nav-dropdown"
                                         variant="secondary">
                                <NavbarBrand href="/dashboard">
                                    <img src={leadtubLogoWhite} alt="logo" className="display-1" style={{
                                        display: 'block',
                                        marginLeft: "auto",
                                        marginRight: "auto",
                                        justifySelf: "center",
                                        width: "8vw"
                                    }}/>
                                </NavbarBrand>

                                <Nav.Link href="/dashboard">
                                        <span className={"navbarspan"}>
                                            <span className="svgPad">
                                                {svgs[0]}
                                            </span>
                                            <span>
                                                Översikt
                                            </span>

                                        </span>
                                </Nav.Link>

                                <Nav.Link href="/leads"> <span className={"navbarspan"}>
                                            <span className="svgPad">
                                                {svgs[1]}
                                            </span>
                                            <span>
                                                Leads
                                            </span>
                                    </span>
                                </Nav.Link>

                                <NavDropdown.Divider/>

                                <Nav.Link href="/users"> <span className={"navbarspan"}>
                                            <span className="svgPad">
                                                {svgs[2]}
                                            </span>
                                            <span>
                                                Användare
                                            </span>
                                    </span>
                                </Nav.Link>


                                <Nav.Link href="/settings"> <span
                                    className={"navbarspan"}>
                                            <span className="svgPad">
                                                {svgs[3]}
                                            </span>
                                            <span>
                                                Inställningar
                                            </span>
                                    </span>
                                </Nav.Link>

                                <Nav.Link href="/contact-us"> <span
                                    className={"navbarspan"}>
                                            <span className="svgPad">
                                                {svgs[4]}
                                            </span>
                                            <span>
                                                Kontakt
                                            </span>
                                    </span>
                                </Nav.Link>

                                <Nav.Link href="/archive"> <span
                                    className={"navbarspan"}>
                                            <span className="svgPad">
                                                {svgs[5]}
                                            </span>
                                            <span>
                                                Arkiv
                                            </span>
                                    </span>
                                </Nav.Link>

                            </NavDropdown>

                            <Nav>

                                <Dropdown className="mr-auto" drop="right">
                                    <Dropdown.Toggle variant="outline-secondary">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                             viewBox="0 0 16 16">
                                            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
                                            <path fillRule="evened"
                                                  d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"/>
                                        </svg>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                    <span>
                        {user?.company}
                    </span>

                                        <Dropdown.Item>
                                            {user?.firstName} {user?.lastName}
                                            <br/>
                                            {user?.email}
                                        </Dropdown.Item>
                                        <Dropdown.Divider/>
                                        <Link to={`/accountdetails/${currentUser.uid}`}>

                                            Kontouppgifter
                                        </Link>
                                        <Dropdown.Item onClick={handleClick} style={{color: 'red'}}>Logga
                                            ut </Dropdown.Item>

                                    </Dropdown.Menu>
                                </Dropdown>

                            </Nav>
                        </Nav>

                    </Container>
                </Navbar>


            ) : null}

        </React.Fragment>
    )
}
export default MobileNavBar;
